<template>
  <div>
    <h1>Signing out...</h1>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  margin-top: 6rem;
  text-align: center;
}
</style>

<script setup lang="ts">
import { onMounted } from 'vue'
import { reloadApp, usePageTitle } from '@/util/AppUtil'
import { useTokenManager } from "@/auth/TokenManager"
import { AsyncUtil } from '@/util/AsyncUtil'

usePageTitle("Signing out")

const tokenManager = useTokenManager()

onMounted(async () => {
    await AsyncUtil.delay(500) // show message
    tokenManager.clearCurrentToken();
    reloadApp("/")
  }
)
</script>